import { ErrorBoundary, Layout } from '@/components';
import HomePage from '@/pages';
import { createBrowserRouter } from 'react-router';

const router = createBrowserRouter([
  {
    errorElement: (
      <Layout>
        <ErrorBoundary />
      </Layout>
    ),
    children: [
      {
        element: <Layout />,
        children: [
          {
            path: '/',
            element: <HomePage />
          }
        ]
      }
    ]
  }
]);

export default router;
